import { ApiSet, BaseResponse, useDownloadApi } from 'utils/network/api_hooks'
import { CraifHttpClient } from '../utils/network/axios'

export function useDownloadUserExportApi(): ApiSet<BaseResponse> & { execute: () => void } {
    const apiPath = 'user_exports/'
    const api = useDownloadApi<BaseResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (): void => {
        api.execute(apiPath, 'users.xlsx')
    }

    return { ...api, execute: execute }
}
